<template>
  <section class="mt-8 mx-5">
    <IconoHeader />
    <div class="d-flex flex-column justify-center align-center">
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold">
            Bienvenid{{
              $store.getters['persona/obtenerGeneroPersona'] == 'H' ? 'o' : 'a'
            }}
            <span v-if="tipoPersona === 1">
              soci{{
                $store.getters['persona/obtenerGeneroPersona'] == 'H'
                  ? 'o'
                  : 'a'
              }}
            </span>
            <br /><span class="text-capitalize">{{
              persona.nombreBienvenida
            }}</span>
          </h2>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <p
            class="text-body-2 text-center grey--text text--darken-2 ma-0 mx-3"
          >
            Validaremos tu número celular, presiona el botón
            <span class="font-weight-black">COMENZAR</span> para recibir un SMS
            de verificación.
          </p>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold">
            {{ celularOferta }}
          </h2>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-dialog v-model="dialogDocumentos" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="align-self-center"
                color="primary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                @click="quitarClases"
                >Comenzar<v-icon right light>mdi-arrow-right</v-icon></v-btn
              >
              <!-- <v-btn
                class="align-self-center"
                color="primary"
                v-bind="attrs"
                v-on="on"
                elevation="3"
                @click="noInteresado"
                >NO INTERESADO DE MOMENTO<v-icon right light
                  >mdi-arrow-left</v-icon
                ></v-btn
              > -->
            </template>
            <v-card class="ma-0 pa-0" cols="5">
              <v-card-title>Antes de comenzar...</v-card-title>
              <v-card-subtitle class="text-body text-center mt-2 py-0"
                >No olvides tener a la mano los documentos que necesitarás
                durante el proceso:</v-card-subtitle
              >
              <v-list disabled class="ma-0 px-3">
                <v-list-item-group color="primary">
                  <v-list-item
                    class="v-item--active v-list-item--active my-2"
                    v-bind:class="{ 'v-list-item__title': false }"
                    v-for="(item, i) in documentosNecesarios"
                    :key="i"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon v-text="item.icono"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        class="font-weight-bold"
                        v-text="item.texto"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-card-actions class="d-flex flex-row justify-end">
                <v-btn
                  @click="continuarAVerificacionOtp"
                  :loading="cargando"
                  :disabled="cargando"
                  elevation="2"
                  color="primary"
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <!--<v-row
        justify="center"
        class="ma-0 pa-0 mt-10 mt-xs-10 mt-sm-10 mt-md-4 mt-lg-4 mt-xl-4"
      >
         <v-col cols="12" class="ma-0 pa-0">
          <p class="text-center grey--text text--darken-2 ma-0">
            ¿No te interesa esta oferta?<br />
            <router-link
              :to="{ name: 'cancelacion' }"
              class="text-body-30 font-weight-bold"
              >Haz click aqui</router-link
            > 
            <v-btn
              :loading="cargando"
              :disabled="cargando"
              elevation="2"
              :to="{ name: 'cancelacion' }"
            >
              ¡HAZ CLICK AQUI PARA CANCELAR!
            </v-btn>
          </p>
        </v-col> 
      </v-row>-->
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import OtpService from '@/servicios/otp'
import { ALERTA_ERROR } from '@/utilidades/utilidades'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  components: { IconoHeader },
  name: 'Bienvenida',
  mixins: [InsertaLogMixin],
  data: () => ({
    dialogDocumentos: false,
    documentosNecesarios: [],
    persona: '',
    tipoPersona: null,
    cargando: false,
    celularOferta: '',
  }),
  created() {
    this.persona = this.$store.getters['persona/obtenerPersona'].datosPersonales
    this.tipoPersona = this.$store.getters['persona/obtenerPersona'].tipoPersona
    this.celularOferta = this.$store.getters['persona/obtenerCelularOferta']
    this.$gtag.event('telefonoOferta', {
      event_category: 'Enter Page',
      event_label: 'Celular de la oferta',
      value: this.celularOferta,
    })
    this.InsertaLog({ notas: 'Celular de la oferta ' + this.celularOferta })
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    this.documentosNecesarios =
      this.$store.getters['personaDocumentos/obtenerDocumentosASolicitar']
  },
  methods: {
    async quitarClases() {
      //documento multilinea
      try {
        setTimeout(() => {
          while (
            document.getElementsByClassName('v-list-item__title').length > 0
          ) {
            document
              .getElementsByClassName('v-list-item__title')[0]
              .classList.remove('v-list-item__title')
          }
        }, 50)
      } catch (error) {
        console.error(error)
      }
    },
    async enviarOtp() {
      this.cargando = true
      const enviarOtpRequest =
        this.$store.getters['persona/obtenerEnviarOtpRequest']
      let result
      try {
        result = await OtpService.EnviarOtp(enviarOtpRequest)
        if (result.data.Codigo != 200 && result.data.Modelo != true) {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargando = false
      } catch {
        this.enviarAlertaError(
          result.data.Mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargando = false
      }
    },
    async continuarAVerificacionOtp() {
      await this.enviarOtp()
      this.$router.push('verificacion-otp')
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
    }),
  },
}
</script>
